// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__qsLy1","error":"Textarea_error__1_Put","readonly":"Textarea_readonly__uNqFU","disabled":"Textarea_disabled__1f4h0"};